export default __webpack_public_path__ + "4889d66a937b7bc5acbf539723e32b76.jpeg";